import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { setSelectedClips } from 'components/app/editor/_mediator/editor.slice';
import { useSelectorContext } from './selector.provider';
import { resetSelector } from './selector.slice';

export const useSelector = () => {
  const { srPlayerPlay } = useSelectorContext();
  const { srPlayerPlayback } = useAppSelector((state) => state.selector);
  const tracksRestored = useAppSelector((state) => state.memory.tracksRestored);
  const selectedFile = useAppSelector((state) => state.projects.selectedFile);
  const selectedStory = useAppSelector((state) => state.projects.selectedStory);
  const activeClip = useAppSelector((state) => state.editor.activeClip);
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetSelector());
    };
  }, [selectedFile, selectedStory]);

  useEffect(() => {
    if (!tracksRestored) return;
    srPlayerPlay(srPlayerPlayback);
  }, [srPlayerPlayback, tracksRestored]);

  useEffect(() => {
    dispatch(setSelectedClips([]));
  }, [activeClip]);
};
